import { render, staticRenderFns } from "./elaborate.vue?vue&type=template&id=1c176536"
import script from "./elaborate.vue?vue&type=script&lang=js"
export * from "./elaborate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports